export enum DateRangeValueType {
  Today = 'today',
  Yesterday = 'yesterday',
  Tomorrow = 'tomorrow',
  ThisWeek = 'this_week',
  LastWeek = 'last_week',
  NextWeek = 'next_week',
  ThisMonth = 'this_month',
  LastMonth = 'last_month',
  ThisQuarter = 'this_quarter',
  LastQuarter = 'last_quarter',
  ThisYear = 'this_year',
  LastYear = 'last_year',
  Last7Days = 'last_7_days',
  Last14Days = 'last_14_days',
  Last20Days = 'last_20_days',
  Last30Days = 'last_30_days',
  Last60Days = 'last_60_days',
  Last90Days = 'last_90_days',
  Last365Days = 'last_365_days',
  Custom = 'custom',
  AllTime = 'all_time',
}

export type TDateRangeValueType =
  | 'today'
  | 'yesterday'
  | 'tomorrow'
  | 'this_week'
  | 'last_week'
  | 'next_week'
  | 'this_month'
  | 'last_month'
  | 'this_quarter'
  | 'last_quarter'
  | 'this_year'
  | 'last_year'
  | 'last_7_days'
  | 'last_14_days'
  | 'last_20_days'
  | 'last_30_days'
  | 'last_60_days'
  | 'last_90_days'
  | 'last_365_days'
  | 'custom'
  | 'all_time';
